var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{staticClass:"undo-button",attrs:{"icon":_vm.icon},on:{"click-event":function($event){return _vm.$store.dispatch('undoHistory')}}})}
var staticRenderFns = []

export { render, staticRenderFns }